import { motion } from "framer-motion";
import { Link, useParams } from "react-router-dom";
import { BusinessDetailPanel } from "@/components/businesses/BusinessDetailPanel";
import { PageSkeleton } from "@/components/ui/PageSkeleton";
import { useBusinessDetail } from "@/lib/queries";

const pageVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export function BusinessDetailPage() {
  const { id } = useParams<{ id: string }>();
  const businessId = Number(id);
  const { data, isLoading, error } = useBusinessDetail(businessId);

  if (isLoading) return <PageSkeleton />;

  if (error || !data?.business) {
    return (
      <motion.div
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
        transition={{ duration: 0.3 }}
        className="space-y-4"
      >
        <Link
          to="/businesses"
          className="inline-block text-sm font-semibold text-muted transition hover:text-foreground"
        >
          ← Businesses
        </Link>
        <p className="text-sm text-muted">Business not found.</p>
      </motion.div>
    );
  }

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to="/businesses"
        className="mb-5 inline-block text-sm font-semibold text-muted transition hover:text-foreground"
      >
        ← Businesses
      </Link>
      <BusinessDetailPanel
        business={data.business}
        connectedService={data.connectedService}
        prices={data.prices}
        customers={data.customers}
        subscriberCars={data.subscriberCars}
        subscriberUsers={data.subscriberUsers}
      />
    </motion.div>
  );
}
